import { useState } from "react";
import { toast } from "react-toastify";
import { Eye, EyeSlash } from "iconsax-reactjs";
import { useNavigate } from "react-router-dom";
import Button from "../../components/commons/Button";
import InputFiel from "../../components/commons/InputFiel";
import { loginWithPassword } from "../../services/webServices/login/post";

export default function Login() {
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!identifier.trim() || !password.trim()) {
      toast.error("لطفا همه فیلدها را تکمیل کنید");
      return;
    }

    setLoading(true);

    const data = await loginWithPassword({
      identifier,
      password,
    });

    if (data) {
      localStorage.setItem("token", data.access);
      localStorage.setItem("refresh", data.refresh);
      localStorage.setItem("role", String(data.role));
      localStorage.setItem("profileInfo", JSON.stringify(data));

      if (data.is_staff) {
        navigate("/", { replace: true });
      }
    }

    setLoading(false);
  };

  return (
    <div className="lg:min-h-screen py-6 flex items-center justify-center">
      <div className="w-4/5 md:w-2/3 lg:w-1/2 bg-white card-shadow rounded-2xl border">
        <div
          className="flex flex-col items-center rounded-2xl p-5 h-full gap-5"
          dir="rtl"
        >
          <div className="flex flex-col items-center gap-2">
            <span className="text-lg">ورود</span>
          </div>

          <div className="w-full flex flex-col gap-5 text-sm">
            <div className="flex flex-col gap-2">
              <label className="text-gray-400">
                ایمیل یا تلفن همراه
              </label>
              <InputFiel
                as="input"
                size="md"
                value={identifier}
                placeholder="ایمیل یا تلفن همراه"
                maxLength="unlimited"
                disabled={loading}
                onChange={(e) => setIdentifier(e.target.value)}
                customClassName="bg-gray-50 border-gray-100"
              />
            </div>

            <div className="flex flex-col gap-2 relative">
              <label className="text-gray-400">رمز عبور</label>
              <InputFiel
                as="input"
                size="md"
                value={password}
                placeholder="رمز عبور"
                maxLength="unlimited"
                disabled={loading}
                onChange={(e) => setPassword(e.target.value)}
                customClassName="bg-gray-50 border-gray-100"
                type={visiblePassword ? "text" : "password"}
              />

              <div
                className="absolute top-9 left-3 cursor-pointer"
                onClick={() => setVisiblePassword((prev) => !prev)}
              >
                {visiblePassword ? (
                  <Eye size="20" color="#ADADAD" variant="Outline" />
                ) : (
                  <EyeSlash
                    size="20"
                    color="#ADADAD"
                    variant="Outline"
                  />
                )}
              </div>
            </div>

            <Button
              variant="primary"
              style="solid"
              size="md"
              text="ورود"
              loading={loading}
              disabled={false}
              onClick={handleLogin}
              customClassName="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};